/*
 * Copyright (c) 2020 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

import { ObservableModel } from '@typescript-kit/core';

// export type AccountingRecordItemUnit = 'piece' | 'm' | 'm2' | 'm3' | 'h' | 'fixed-amount';
//
// export class AccountingRecordItemUnits {
//   static readonly PIECE: AccountingRecordItemUnit = 'piece';
//   static readonly M: AccountingRecordItemUnit = 'm';
//   static readonly M2: AccountingRecordItemUnit = 'm2';
//   static readonly M3: AccountingRecordItemUnit = 'm3';
//   static readonly H: AccountingRecordItemUnit = 'h';
//   static readonly FIXED_AMOUNT: AccountingRecordItemUnit = 'fixed-amount';
// }

export interface AccountingRecordItemData {
  description?: string;
  amount?: number;
  unit?: string;
  unitCosts?: number;
}

export class AccountingRecordItemFieldKey {
  static readonly DESCRIPTION = 'description';
  static readonly AMOUNT = 'amount';
  static readonly UNIT = 'unit';
  static readonly UNIT_COSTS = 'unitCosts';
}

export class AccountingRecordItem implements AccountingRecordItemData {
  readonly description: string;
  readonly amount: number;
  readonly unit: string;
  readonly unitCosts: number;

  constructor(data: AccountingRecordItemData) {
    this.description = data.description;
    this.amount = data.amount;
    this.unit = data.unit;
    this.unitCosts = data.unitCosts;
  }
}

export class AccountingRecordItemModel extends ObservableModel implements AccountingRecordItemData {
  static readonly KEYS = Object.keys(AccountingRecordItemFieldKey).map((key: string) => AccountingRecordItemFieldKey[key]);

  constructor(data: AccountingRecordItemData) {
    super(data, AccountingRecordItemModel.KEYS);
  }

  get description(): string {
    return this.get(AccountingRecordItemFieldKey.DESCRIPTION);
  }

  set description(value: string) {
    this.set(AccountingRecordItemFieldKey.DESCRIPTION, value);
  }

  get amount(): number {
    return this.get(AccountingRecordItemFieldKey.AMOUNT);
  }

  set amount(value: number) {
    this.set(AccountingRecordItemFieldKey.AMOUNT, value);
  }

  get unit(): string {
    return this.get(AccountingRecordItemFieldKey.UNIT);
  }

  set unit(value: string) {
    this.set(AccountingRecordItemFieldKey.UNIT, value);
  }

  get unitCosts(): number {
    return this.get(AccountingRecordItemFieldKey.UNIT_COSTS);
  }

  set unitCosts(value: number) {
    this.set(AccountingRecordItemFieldKey.UNIT_COSTS, value);
  }

}
